"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var foundation_legacy_1 = require("@fluentui/foundation-legacy");
var Text_view_1 = require("./Text.view");
var Text_styles_1 = require("./Text.styles");
exports.Text = foundation_legacy_1.createComponent(Text_view_1.TextView, {
    displayName: 'Text',
    styles: Text_styles_1.TextStyles,
});
exports.default = exports.Text;
//# sourceMappingURL=Text.js.map